import styled from 'styled-components';

export const ForgotLoginLink = styled.div`
  text-align: center;
  margin-bottom: var(--spacing-regular);
    color: var(--color-highlight);
  cursor: pointer;
  font-size: var(--font-paragraph);
`;
